import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { MdMoreVert } from "react-icons/md";
import UserCard from "../../components/user/UserCard";
import ButtomButton from "../../components/DocButtomButton";
import {
  fetchCommunity,
  joinCommunity,
  fetchCommunityMembers,
  leaveCommunity,
} from "../../actions/community.action";
import { Loading } from "../../utils/helpers/constants";
import RoundLoader from "../../components/loader/RoundLoader";
import AnnouncementImg from "../../assets/images/LandingPage/announcement.jpg";

export default function CommunityDetails() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCommunity(id));
    dispatch(fetchCommunityMembers(id));
  }, []);

  const {
    community: {
      community,
      communityLoading,
      joinCommunityLoading,
      creator,
      membersLoading,
      communityMembers,
      userMember,
    },
  } = useSelector(({ communityReducer }) => ({
    community: communityReducer,
  }));

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const handleAttending = () => {
    dispatch(joinCommunity(id, community.name));
  };

  const handleLeave = () => {
    dispatch(leaveCommunity(id, community.name));
  };

  const handleProfile = () => {
    history.push(`/profile/user/${community.id}`);
  };

  const buttonLoadState = joinCommunityLoading === Loading.FETCHING;
  const loadState =
    communityLoading === Loading.FETCHING ||
    membersLoading === Loading.FETCHING ||
    profile.userProfileLoading === Loading.FETCHING;

  return (
    <div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <div>
          <div className="mt-10 mx-5">
            <div className="flex justify-between mb-5">
              <div className="flex cursor-pointer">
                <AiOutlineArrowLeft
                  size={25}
                  onClick={() => history.goBack()}
                />
              </div>
              <div className="single_line font-bold text-xl font-serif mx-2">
                {community.name}
              </div>
              <div></div>
            </div>

            <div className="rounded w-full md:flex md:justify-between">
              <div className="md:mr-10 md:w-1/2">
                <img
                  className="object-fill w-full h-72"
                  src={
                    community.imageUrl === null
                      ? AnnouncementImg
                      : community.imageUrl
                  }
                  alt={community.name}
                />
              </div>
              <div className="py-4 md:border-l  md:w-1/2  md:p-4">
                <div>
                  <div className={`text-xs mb-2`}>
                    <span className="text-sm text-gray-400 mb-1 pr-2">
                      Number of Members:
                    </span>
                    <div>{community.noOfMembers}</div>
                  </div>
                  <div className="text-sm text-gray-400 mb-1">Description:</div>
                  <div className={`text-xs mb-2`}>{community.description}</div>
                  <div className="mb-2">
                    <div className="text-sm text-gray-400 mb-2">Creator</div>
                    <UserCard
                      user={creator}
                      handleProfile={() => handleProfile()}
                    />
                  </div>
                  <hr />
                  <div className="mt-5">
                    <div className="text-sm text-gray-400 mb-2">Members</div>
                    {communityMembers.map((m) => {
                      return (
                        <div className="mb-2 hover:bg-gray-200 hover:p-2 hover:rounded-md">
                          <UserCard
                            user={m}
                            handleProfile={() => handleProfile()}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
                {userMember ? (
                  <ButtomButton
                    name={"Leave"}
                    func={handleLeave}
                    loading={buttonLoadState}
                  />
                ) : (
                  <ButtomButton
                    name={"Join"}
                    func={handleAttending}
                    loading={buttonLoadState}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
